import { ExternalLink } from 'lucide-react';

const BOOK_COVER = "https://customer-assets.emergentagent.com/job_citizen-refresh/artifacts/fu066grm_PAPERBACK_FrontCover.jpg";
const SONG_COVER = "https://customer-assets.emergentagent.com/job_citizen-refresh/artifacts/fdx98c46_NoBordersCoverArt.jpg";
const APP_SCREENSHOT = "https://customer-assets.emergentagent.com/job_citizen-refresh/artifacts/sdwtdwix_IMG_1014.PNG";

export default function MediaSection() {
  return (
    <section
      id="brand-story"
      data-testid="brand-story-section"
      className="relative py-16 md:py-20 bg-[#efeee9]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center mb-10">
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#1a7a7a] mb-3 font-medium"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Published Works
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            From the Founders
          </h2>
        </div>

        {/* Reduced size: max-w-3xl centers the grid, smaller aspect ratios */}
        <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto">
          {/* Song */}
          <a
            href="https://music.apple.com/us/album/no-borders-on-our-dreams-single/1881247564"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="apple-music-link"
            className="group relative rounded-xl overflow-hidden bg-white border border-gray-200 hover:border-[#1a7a7a]/40 hover:shadow-md transition-all duration-500"
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={SONG_COVER}
                alt="No Borders on Our Dreams"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <h3
                className="text-sm font-semibold text-white mb-0.5"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                The Anthem
              </h3>
              <p className="text-gray-300 text-[10px] mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                "No Borders on Our Dreams"
              </p>
              <div className="flex items-center gap-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                <span className="text-[10px] text-white/80 font-medium flex items-center gap-1">
                  Apple Music <ExternalLink size={8} />
                </span>
                <span className="text-white/40">|</span>
                <span
                  className="text-[10px] text-white/80 font-medium flex items-center gap-1 cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open("https://open.spotify.com/album/6b7qImvJf6PgzZ7fDKgoej?si=Ho-5sjteT8-7FsZzwVfguA", "_blank");
                  }}
                  data-testid="spotify-link"
                >
                  Spotify <ExternalLink size={8} />
                </span>
              </div>
            </div>
          </a>

          {/* Book */}
          <a
            href="https://amzn.to/49PZdvQ"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="book-amazon-link"
            className="group relative rounded-xl overflow-hidden bg-white border border-gray-200 hover:border-[#1a7a7a]/40 hover:shadow-md transition-all duration-500"
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={BOOK_COVER}
                alt="The Global Freedom Blueprint"
                data-testid="book-cover-image"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <h3
                className="text-sm font-semibold text-white mb-0.5"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                The Book
              </h3>
              <p className="text-gray-300 text-[10px] mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                The Global Freedom Blueprint
              </p>
              <span className="text-[10px] text-white/80 font-medium flex items-center gap-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Order on Amazon <ExternalLink size={8} />
              </span>
            </div>
          </a>

          {/* App */}
          <a
            href="https://apps.apple.com/us/app/global-citizen-app/id6759657870"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="app-store-link"
            className="group relative rounded-xl overflow-hidden bg-white border border-gray-200 hover:border-[#1a7a7a]/40 hover:shadow-md transition-all duration-500"
          >
            <div className="aspect-square overflow-hidden bg-[#efeee9] flex items-center justify-center">
              <img
                src={APP_SCREENSHOT}
                alt="Global Citizen App"
                className="w-[55%] h-auto rounded-xl shadow-xl group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-3" data-testid="app-promo-section">
              <h3
                className="text-sm font-semibold text-white mb-0.5"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                The App
              </h3>
              <p className="text-gray-300 text-[10px] mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Global Citizen Companion
              </p>
              <div className="flex items-center gap-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                <span className="text-[10px] text-white/80 font-medium flex items-center gap-1">
                  App Store <ExternalLink size={8} />
                </span>
                <span className="text-white/40">|</span>
                <span
                  className="text-[10px] text-white/80 font-medium flex items-center gap-1 cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open("https://play.google.com/store/apps/details?id=app.rork.global_citizen_app&pcampaignid=web_share", "_blank");
                  }}
                  data-testid="google-play-link"
                >
                  Google Play <ExternalLink size={8} />
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
